<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ inquiryListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:90px">
        <col style="width:30px">
        <col style="width:auto">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                @change="toggleAllCheck($event.target.checked)"
              >
              <label for=""></label>
            </span>
          </th>
          <th scope="col">번호</th>
          <th scope="col">제목</th>
          <th scope="col" width="80px">답변 유무</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(inquiry, index) in inquiryList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                :value="inquiry.inquirySeq"
                v-model="selectedInquiries"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ inquiry.number }}</td>
          <td class="content"><a @click="toInquiry(inquiry.inquirySeq)">{{ inquiry.questionTitle }}</a></td>
          <td>{{ inquiry.isAnswered == 'Y' ? '답변 완료' : '답변 대기' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <!-- <button type="button" class="bt_base primary large_h" @click="createPartner">제휴기관 등록</button> -->
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedInquiries">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminInquiryModule = 'adminInquiryModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedInquiries: [],

      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '답변 완료', value: 'answered' },
        { name: '답변 대기', value: 'notAnswered' },
      ],
      searchType: 'all',
      searchWord: ''
    }
  },
  methods: {
    ...mapActions(adminInquiryModule, [
      'requestInquiryList',
    //   'requestDeleteInquiries',
    ]),

    toInquiry (inquirySeq) {
      this.$router.push({ name: "InquiryAnswerPage", query: { inquirySeq } })
    },

    totalPages() {
      return Math.ceil(this.inquiryListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestInquiryList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.inquiryListCount)) {
        currentLastCount = this.inquiryListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedInquiries = []
        for (const inquiry of this.inquiryList) {
          this.selectedInquiries.push(inquiry.inquirySeq)
        }
      } else {
        this.selectedInquiries = []
      }
    },

    // async deleteSelectedInquiries() {
    //   if (this.selectedInquiries.length === 0) {
    //     alert('선택된 기관이 없습니다');
    //     return;
    //   }

    //   const { searchType, searchWord, currentPage } = this;
    //   const fetchInquiries = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
    //     const params = { currentPage: page, searchType: type, searchWord: word };
    //     await this.requestInquiryList(params);
    //     if (isReset) {
    //       this.searchType = 'all';
    //     }
    //   };

    //   await this.requestDeleteInquiries(this.selectedInquiries);
    //   this.selectedInquiries = [];

    //   await fetchInquiries(currentPage);

    //   if (this.inquiryList.length === 0 && this.currentPage > 1) {
    //     this.currentPage -= 1;
    //     await fetchInquiries(this.currentPage);
    //   }

    //   if (this.inquiryList.length === 0 || this.currentPage === 1) {
    //     this.currentPage = 1;
    //     this.searchType = '';
    //     this.searchWord = '';
    //     await fetchInquiries(1, '', '', true);
    //   }
    // },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestInquiryList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminInquiryModule, [
      'inquiryList',
      'inquiryListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestInquiryList({ currentPage, searchType, searchWord })
  }
}
</script>
<style lang="">
    
</style>